import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { Auth } from "./../../providers/auth/auth";
import { Subscription } from "rxjs/Subscription";
import { Company } from "../../models/company";
import { User } from "../../models/user";
import * as UserActions from "../../actions/user.actions";

// ngrx/store
import { Store } from "@ngrx/store";
import * as fromRoot from "../../reducers";

@Component({
  selector: "flex",
  templateUrl: "flex.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlexComponent {
  @Input() company: Company;
  @Input() user: User;
  @Input() ebitMarginExpectation: number;

  level: string = "revenue";
  defaults: any;
  flex: any;
  ticker: string;
  valueDriverCategories: string[] = [
    "revenueGrowthRate",
    "ebitMargin",
    "wci",
    "fai",
  ];
  flexesSubscription: Subscription;
  rerender = false;

  public new: any = { componentsOfValue: {}, valueDrivers: {} };

  constructor(
    private store: Store<fromRoot.State>,
    private cdRef: ChangeDetectorRef,
    public authProvider: Auth
  ) {}

  ngOnChanges() {
    if (!this.company || !this.user) return;
    this.flexesSubscription && this.flexesSubscription.unsubscribe();
    //Get the default flexes
    this.ticker = this.company.ticker;
    this.defaults = this.company.platformData;
    this.flex = this.user.flexes[this.ticker] || null;
    if (!this.flex || !this.flex.valueDrivers)
      this.flex = this.initialise(this.defaults);
    this.flex = this.padOutFlex(this.flex, this.defaults);
    this.flex = this.convPercentToWhole(this.flex);
  }

  initialise(defaults) {
    let flex = {
      unsaved: true,
      useFlex: true,
      valueDrivers: {},
      componentsOfValue: {},
      discountRate: undefined,
      taxShield: undefined,
    };

    // if (!flex.hasOwnProperty('taxShield')) flex.rates.taxShield = undefined;
    // if (!flex.hasOwnProperty('discountRate')) flex.rates.discountRate = undefined;

    this.valueDriverCategories.forEach((cat) => {
      flex.valueDrivers[cat] = defaults.valueDrivers[cat].map((item) => {
        return { year: item.year };
      });
    });

    for (let i in defaults.componentsOfValue) {
      flex.componentsOfValue[i] = undefined;
    }

    return flex;
  }

  getDisplayflex(val) {
    if (val) {
      return val * 100;
    } else {
      return undefined;
    }
  }

  convWholeToPercent(fl) {
    let flex = JSON.parse(JSON.stringify(fl));
    if (flex.valueDrivers) {
      for (let f of Object.keys(flex.valueDrivers)) {
        flex.valueDrivers[f] = flex.valueDrivers[f].map((i) => {
          if (!i) return;
          if (!i.value) {
            return { year: i["year"], value: undefined, changed: i.changed };
          } else {
            return i.value
              ? { year: i["year"], value: i.value / 100, changed: i.changed }
              : {};
          }
        });
      }
    }
    if (
      flex.componentsOfValue &&
      flex.componentsOfValue.hasOwnProperty("taxRate")
    ) {
      //Has a tax tate
      if (
        flex.componentsOfValue.taxRate != 0 &&
        flex.componentsOfValue.taxRate != ""
      ) {
        //Converting tax rate to percentage
        flex.componentsOfValue.taxRate = flex.componentsOfValue.taxRate / 100;
      } else {
        flex.componentsOfValue.taxRate = undefined;
      }
    }
    if (flex.hasOwnProperty("taxShield")) {
      //Has a tax tate
      if (flex.taxShield != 0 && flex.taxShield != "") {
        //Converting tax rate to percentage
        flex.taxShield = flex.taxShield / 100;
      } else {
        flex.taxShield = undefined;
      }
    }
    if (flex.hasOwnProperty("discountRate")) {
      //Has a tax tate
      if (flex.discountRate != 0 && flex.discountRate != "") {
        //Converting tax rate to percentage
        flex.discountRate = flex.discountRate / 100;
      } else {
        flex.discountRate = undefined;
      }
    }

    if (flex.componentsOfValue.hasOwnProperty("sharePrice")) {
      //Has a tax tate
      if (
        flex.componentsOfValue.sharePrice != 0 &&
        flex.componentsOfValue.sharePrice != ""
      ) {
        //Converting tax rate to percentage
        flex.componentsOfValue.sharePrice =
          flex.componentsOfValue.sharePrice / 1;
        flex.componentsOfValue.marketCap =
          flex.componentsOfValue.sharePrice *
          this.defaults.componentsOfValue.currentSharesOutstanding;
      } else {
        flex.componentsOfValue.sharePrice = undefined;
      }
    }
    return flex;
  }

  convPercentToWhole(fl) {
    let flex = JSON.parse(JSON.stringify(fl));
    for (let f of Object.keys(flex.valueDrivers)) {
      flex.valueDrivers[f] = flex.valueDrivers[f].map((i) => {
        if (!i) return;
        if (!i.value) {
          return { year: i["year"], value: undefined, changed: i.changed };
        } else {
          return i.value
            ? {
                year: i["year"],
                value: Math.round(i.value * 1000) / 10,
                changed: i.changed,
              }
            : {};
        }
      });
    }
    if (
      flex.componentsOfValue &&
      flex.componentsOfValue.hasOwnProperty("taxRate")
    ) {
      //Has a tax tate
      if (flex.componentsOfValue.taxRate != 0) {
        //Converting tax rate to percentage
        flex.componentsOfValue.taxRate = flex.componentsOfValue.taxRate * 100;
      }
    }
    if (flex.hasOwnProperty("taxShield")) {
      //Has a tax tate
      if (flex.taxShield != 0) {
        //Converting tax rate to percentage
        flex.taxShield = flex.taxShield * 100;
      }
    }
    if (flex.hasOwnProperty("discountRate")) {
      //Has a tax tate
      if (flex.discountRate != 0) {
        //Converting tax rate to percentage
        flex.discountRate = flex.discountRate * 100;
      }
    }

    return flex;
  }

  padOutFlex(fl, defaults) {
    let flex = JSON.parse(JSON.stringify(fl));

    if (!flex.componentsOfValue) flex.componentsOfValue = {};

    for (let i in defaults.componentsOfValue) {
      if (!flex.componentsOfValue.hasOwnProperty(i)) {
        flex.componentsOfValue[i] = undefined;
      }
    }

    return flex;
  }

  toggleFlexChanged(event) {
    const newValue = event.value;
    this.flex.useFlex = newValue;
    if (this.flex.unsaved) {
      //Its not in the database yet
      if (newValue) {
        //Its been changed to TRUE
        //Do nothing
      } else {
        //Its been changed to FALSE
        //Do nothing
      }
    } else {
      //Its in the database
      if (newValue) {
        //Its been changed to TRUE
        this.applyFlex(this.flex);
      } else {
        //Its been changed to FALSE
        this.applyFlex(this.flex);
      }
    }
  }

  ngOnDestroy() {
    console.info("DESTROYING the CompanySideBarComponent component");
  }

  resetFlex() {
    this.flex = JSON.parse(JSON.stringify(this.initialise(this.defaults)));

    this.applyFlex(this.flex);
    this.doRerender();
  }
  doRerender() {
    this.rerender = true;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.rerender = false;
    }, 0);
  }

  applyFlex(flex: any = this.flex) {
    // Dont do the merge here, do it on the calculate component
    // const res = merge({}, this.defaults, newFlexOptions);
    delete this.flex["unsaved"];
    this.flex = this.convWholeToPercent(flex);
    this.store.dispatch(
      new UserActions.SaveFlex({
        ticker: this.company.ticker.replace(".", ""),
        user_id: this.user._id,
        flex: this.flex,
      })
    );
  }

  setValueDriverItem(item, idx) {}

  valueChange(category, i, val, fillLastValue = false) {
    console.log(category, i, val);
    //Update all future years data based on this one
    if (!val) return;
    const lastIndex = fillLastValue
      ? this.flex.valueDrivers[category].length
      : this.flex.valueDrivers[category].length - 1;
    this.flex.valueDrivers[category].forEach((f, index) => {
      if (index < i || index == lastIndex) {
        return;
      } else {
        f.value = val;
        //Mark this value as changed
        f.changed = true;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/flex/flex.ts